<template>
  <NavigationLayout
    :navigation-content-style="{
      'padding-top': 'calc(var(--safe-area-inset-top, 0px) + 60px)',
    }"
  >
    <SiteHeader
      slot="header"
      :username="user != null ? user.username : ''"
      :coin="coin"
      :icon-url="user != null ? user.iconUrl : ''"
      :loaded="isLoadingComplete"
      :is-transfer-ng-region="ipRegionIsTransferNG"
      :can-use-live2d="canUseLive2DModelUpload"
    />
    <SegmentedNav slot="contents" class="mypage__web_shop_nav" />
    <div id="mypage__wrapper" slot="contents" :class="localeClass">
      <div id="mypage__container">
        <section
          v-if="!isUserWebview && medias.length > 0"
          class="lives_section"
        >
          <ListSubheader
            :title="$t('officialLive')"
            :subheader-style="SubHeaderWhite"
          />

          <div class="lives_wrapper">
            <live-image
              v-for="media of medias"
              :key="media.mediaId"
              :media="media"
            />
          </div>
        </section>

        <!-- コンビニ決済注文情報 -->
        <section
          v-if="
            showPaymentPendingInfo &&
            showPaymentPendingProviderId == ProviderIdTypes.Stripe
          "
          class="bl_coinPurchasePending_wrapper"
        >
          <div
            v-for="(purchaseStatus, index) in purchaseStatusList"
            :key="purchaseStatus.purchaseId"
          >
            <div class="bl_coinPurchasePending">
              <coin-purchase-pending :show-cont-main="index == 0" />
              <DangerButton
                v-show="showPaymentPendingInfo"
                :disabled="!isLoadingComplete"
                @click.native="
                  purchaseCancel(
                    purchaseStatus.purchaseId,
                    ProviderIdTypes.Stripe
                  )
                "
              >
                {{ $t('convenience_store_settlement__button___cancel') }}
              </DangerButton>
            </div>
          </div>
        </section>

        <!-- PayPay決済注文情報 -->
        <section
          v-if="
            showPaymentPendingInfo &&
            showPaymentPendingProviderId == ProviderIdTypes.PayPay
          "
          class="bl_coinPurchasePending_wrapper"
        >
          <div
            v-for="(purchaseStatus, index) in purchaseStatusList"
            :key="purchaseStatus.purchaseId"
          >
            <div class="bl_coinPurchasePending">
              <coin-purchase-pending-pay-pay :show-cont-main="index == 0" />
              <PrimaryButton
                v-show="showPaymentPendingInfo && paypayTransactionUrl"
                :disabled="!isLoadingComplete"
                @click.native="moveToPayPayPurchase"
              >
                {{ $t('paypayPaymentOrderReturnToPayPayPaymentScreen') }}
              </PrimaryButton>
              <DangerButton
                v-show="showPaymentPendingInfo"
                :disabled="!isLoadingComplete"
                @click.native="
                  purchaseCancel(
                    purchaseStatus.purchaseId,
                    ProviderIdTypes.PayPay
                  )
                "
              >
                {{ $t('buttonCancel') }}
              </DangerButton>
            </div>
          </div>
        </section>

        <!-- コイン増量適用商品購入処理中画面 -->
        <section
          v-if="showPaymentPendingInfo && showInProgressCoinPurchaseBonus"
          class="bl_coinPurchasePending_wrapper"
        >
          <div class="bl_coinPurchasePending">
            <coin-purchase-pending-coin-purchase-bonus :show-cont-main="true" />
          </div>
        </section>

        <section v-if="canShowWebGlViewerAfd2025()">
          <div class="afd-banner-center-div">
            <router-link to="/next_reality_viewer">
              <img
                v-if="isJapanese"
                src="https://reality-public.akamaized.net/app_image/mypage/2025_next_reality_viewer_banner_jp.jpg"
              />
              <img
                v-else
                src="https://reality-public.akamaized.net/app_image/mypage/2025_next_reality_viewer_banner_en.jpg"
              />
            </router-link>
          </div>
        </section>

        <section
          v-show="chargeGrade && !showPaymentPendingInfo"
          class="charge_grade_wrapper"
        >
          <div class="charge_grade_group">
            <div
              class="charge_grade_item"
              :style="styleChargeGradeBackgroundImage"
            >
              <div v-if="chargeGrade" class="charge_grade_status">
                <div class="charge_grade_status_detail">
                  <div class="charge_grade_status_detail_title">
                    {{ $t('coinshop__grade_table__caption') }}
                  </div>
                  <div
                    v-if="currentChargeGradeThreshold"
                    class="charge_grade_status_detail_icon_block"
                  >
                    <div
                      v-if="currentChargeGradeThreshold.lowAmountRange > 0"
                      class="charge_grade_status_detail_icon_block_icon_img"
                    >
                      <img
                        :src="currentChargeGradeThreshold.statusIconUrl"
                        :alt="currentChargeGradeThreshold.name"
                      />
                    </div>
                    <div
                      class="charge_grade_status_detail_icon_block_icon_title"
                    >
                      {{ currentChargeGradeThreshold.name }}
                    </div>
                    <div
                      v-if="vipPointInfo"
                      class="charge_grade_status_detail_icon_block_icon_vip_point"
                    >
                      <router-link :to="{ name: 'vip_point_shop' }">
                        <div class="vip_point_link">
                          <span class="vip_point_text">{{
                            $t('vipPoint')
                          }}</span>
                          <span class="vip_point_amount">{{
                            formatNumber(vipPoint)
                          }}</span>
                          <img
                            src="/img/right_arrow.svg"
                            class="vip_point_arrow"
                          />
                        </div>
                      </router-link>
                    </div>
                  </div>
                </div>
                <a :href="chargeGrade.prizeDetailUrl">
                  <img src="/img/info.png" width="24"
                /></a>
              </div>
              <div
                class="charge_grade_progress"
                :style="styleChargeGradeProgress"
              >
                <div
                  class="charge_grade_progress_bar"
                  :style="styleChargeGradeProgressBar"
                />
                <div class="charge_grade_progress_bar_wrapper">
                  <div class="charge_grade_progress_icon_center" />
                </div>
                <div class="charge_grade_progress_bar_wrapper">
                  <div
                    class="charge_grade_progress_bar_gauge"
                    :style="styleChargeGradeProgressBarGauge"
                  />
                </div>
                <div class="charge_grade_progress_bar_wrapper">
                  <div class="charge_grade_progress_center_point" />
                </div>
                <div class="charge_grade_progress_bar_wrapper">
                  <div class="charge_grade_progress_right_point" />
                </div>
                <div
                  v-if="centerChargeGradeThreshold"
                  class="charge_grade_progress_icon_center"
                >
                  <router-link
                    :to="{
                      path: changeInternalLink(
                        centerChargeGradeThreshold.prizeDetailUrl
                      ),
                    }"
                  >
                    <img
                      :src="centerChargeGradeThreshold.statusIconUrl"
                      :alt="centerChargeGradeThreshold.name"
                      width="20px"
                      style="display: block; margin: auto"
                    />
                  </router-link>
                </div>
                <div
                  v-if="rightChargeGradeThreshold"
                  class="charge_grade_progress_icon_right"
                >
                  <router-link
                    :to="{
                      path: changeInternalLink(
                        rightChargeGradeThreshold.prizeDetailUrl
                      ),
                    }"
                  >
                    <img
                      :src="rightChargeGradeThreshold.statusIconUrl"
                      :alt="rightChargeGradeThreshold.name"
                      width="20px"
                      style="display: block; margin: auto"
                    />
                  </router-link>
                </div>
                <div class="charge_grade_progress_coin">
                  <div
                    ref="chargeGradeProgressCoin"
                    class="charge_grade_progress_coin_wrapper"
                    :style="styleChargeGradeProgressCoin"
                  >
                    {{ totalChargeGradeAmount }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- 次月コイン増量 -->
        <section
          v-if="
            coinPurchaseBonus &&
            canPurchaseCoinPurchaseBonus &&
            !showPaymentPendingInfo
          "
          class="coin_purchase_bonus_wrapper"
        >
          <div class="coin_purchase_bonus_content">
            <div class="coin_purchase_bonus_content_top">
              <p
                class="coin_purchase_bonus_content_top_text"
                v-html="$t('coinPurchaseBonusMonthlyGradeBonusHeadText')"
              ></p>
              <p class="coin_purchase_bonus_content_rate">
                {{
                  $t('coinPurchaseBonusRateText', {
                    rate: coinPurchaseBonus.rate,
                  })
                }}
              </p>
            </div>
            <div class="coin_purchase_bonus_content_limit_display">
              <!-- 購入可能回数が初回のみ（１回）の場合 -->
              <p
                v-if="coinPurchaseBonus.remainingTimes == 1"
                class="coin_purchase_bonus_content_limit_display_text"
              >
                {{ $t('coinPurchaseBonusFirstLimitedValidText') }} /
                {{ getRemainTimeForCoinPurchaseBonus(coinPurchaseBonus.endAt) }}
              </p>
              <!-- 購入可能回数が複数回の場合 -->
              <p
                v-else-if="coinPurchaseBonus.remainingTimes > 1"
                class="coin_purchase_bonus_content_limit_display_text"
              >
                {{
                  $t('coinPurchaseBonusLimitedCountValidText', {
                    count: coinPurchaseBonus.remainingTimes,
                  })
                }}
                /
                {{ getRemainTimeForCoinPurchaseBonus(coinPurchaseBonus.endAt) }}
              </p>
            </div>
            <div class="coin_purchase_bonus_content_bottom">
              <p class="coin_purchase_bonus_content_bottom_text">
                {{ $t('coinPurchaseBonusNote01') }}
              </p>
              <p class="coin_purchase_bonus_content_bottom_text">
                {{ $t('coinPurchaseBonusMonthlyGradeBonusNote') }}
              </p>
              <p class="coin_purchase_bonus_content_bottom_text">
                {{ $t('coinPurchaseBonusMonthlyGradeBonusNote2') }}
              </p>
            </div>
          </div>
        </section>

        <div v-if="!showPaymentPendingInfo">
          <section
            v-for="(productGroup, key) in groupingProducts.campaign"
            :key="`campaign-product-${key}`"
            class="campaign_group_wrapper"
          >
            <div class="campaign_group">
              <div class="coin_group_title">
                <p>
                  <b>{{ $t('reality_for_web__title__coin_campaign') }}</b>
                </p>
              </div>

              <div class="coin_list">
                <div
                  v-for="product in productGroup.products"
                  :key="product.productId"
                  class="coin_item"
                  @click="moveToPurchase(product)"
                >
                  <div>
                    <div class="coin_purchase">
                      <coin-product
                        :amount="product.totalGem"
                        :charge-gem="product.chargeGem"
                        :free-gem="product.freeGem"
                        :limited-count="getProductLimitedCount(product)"
                        :show-unit="false"
                        :use-icons-by-coin-amount="true"
                        :should-show-time-limit="shouldShowTimeLimit(product)"
                        :time-limit-text="
                          getRemainTime(productGroup.products[0].endTime)
                        "
                        :is-campaign-product="true"
                        :bonus-gem="
                          calculateBonusAmount(
                            product.chargeGem,
                            coinPurchaseBonusRate
                          )
                        "
                      />
                    </div>
                  </div>
                  <PrimaryButton class="coin_price">
                    {{ product.formattedPrice }}
                  </PrimaryButton>
                </div>
              </div>
            </div>
          </section>

          <section
            v-for="(productGroup, key) in groupingProducts.oncePurchase"
            :key="`once-campaign-product-${key}`"
            class="campaign_group_wrapper"
          >
            <div class="campaign_group">
              <div class="coin_group_title">
                <p>
                  <b>{{ $t('reality_for_web__title__coin_once_purchase2') }}</b>
                </p>
              </div>

              <div class="coin_list">
                <div
                  v-for="product in productGroup.products"
                  :key="product.productId"
                  class="coin_item"
                  @click="moveToPurchase(product)"
                >
                  <div>
                    <div class="coin_purchase">
                      <coin-product
                        :amount="product.totalGem"
                        :charge-gem="product.chargeGem"
                        :free-gem="product.freeGem"
                        :limited-count="1"
                        :show-unit="false"
                        :should-show-time-limit="
                          shouldShowTimeLimitForOnceProduct(product)
                        "
                        :use-icons-by-coin-amount="true"
                        :time-limit-text="getRemainTime(product.productEndTime)"
                        :bonus-gem="
                          calculateBonusAmount(
                            product.chargeGem,
                            coinPurchaseBonusRate
                          )
                        "
                      />
                    </div>
                  </div>
                  <PrimaryButton class="coin_price">
                    {{ product.formattedPrice }}
                  </PrimaryButton>
                </div>
              </div>
            </div>
          </section>

          <section
            v-for="(productGroup, key) in groupingProducts.monthlyCoin"
            :key="`montyly-coin-product-${key}`"
            class="campaign_group_wrapper"
          >
            <div class="campaign_group">
              <div class="coin_group_title">
                <p>
                  <b>{{ $t('reality_for_web__title__coin_monthly') }}</b>
                </p>
              </div>

              <div class="coin_list">
                <div
                  v-for="product in productGroup.products"
                  :key="product.productId"
                  class="coin_item"
                  @click="moveToPurchase(product)"
                >
                  <div>
                    <div class="coin_purchase">
                      <coin-product
                        :amount="product.totalGem"
                        :charge-gem="product.chargeGem"
                        :free-gem="product.freeGem"
                        :limited-count="getProductLimitedCount(product)"
                        :show-unit="false"
                        :use-icons-by-coin-amount="true"
                        :should-show-time-limit="shouldShowTimeLimit(product)"
                        :time-limit-text="
                          getRemainTime(productGroup.products[0].endTime)
                        "
                        :bonus-gem="
                          calculateBonusAmount(
                            product.chargeGem,
                            coinPurchaseBonusRate
                          )
                        "
                      />
                    </div>
                  </div>
                  <PrimaryButton class="coin_price">
                    {{ product.formattedPrice }}
                  </PrimaryButton>
                </div>
              </div>
            </div>
          </section>

          <!-- INFO: 以下はキャンペーン以外の商品一覧 -->
          <section
            v-for="(productGroup, key) in groupingProducts.default"
            :key="`default-product-${key}`"
            class="campaign_group_wrapper"
          >
            <div class="campaign_group">
              <div class="coin_group_title">
                <p>
                  <b>{{ $t('reality_for_web__title__coin_default') }}</b>
                </p>
              </div>

              <div class="coin_list">
                <div
                  v-for="product in productGroup.products"
                  :key="product.productId"
                  class="coin_item"
                  @click="moveToPurchase(product)"
                >
                  <div>
                    <div class="coin_purchase">
                      <coin-product
                        :amount="product.totalGem"
                        :charge-gem="product.chargeGem"
                        :free-gem="product.freeGem"
                        :limited-count="getProductLimitedCount(product)"
                        :show-unit="false"
                        :use-icons-by-coin-amount="true"
                        :should-show-time-limit="shouldShowTimeLimit(product)"
                        :time-limit-text="
                          getRemainTime(productGroup.products[0].endTime)
                        "
                        :bonus-gem="
                          calculateBonusAmount(
                            product.chargeGem,
                            coinPurchaseBonusRate
                          )
                        "
                      />
                    </div>
                  </div>
                  <PrimaryButton class="coin_price">
                    {{ product.formattedPrice }}
                  </PrimaryButton>
                </div>
              </div>
            </div>
          </section>
        </div>

        <!-- 課金制限（18歳未満の月間課金上限）の当月利用額 -->
        <section v-if="chargeLimit" class="charge_limit_wrapper">
          <p class="charge_limit_label">
            {{ $t('charge_limit__current_month_purchasable_amount') }}
          </p>
          <p class="charge_limit_progress">
            {{ chargeLimitProgressText }}
          </p>
        </section>

        <section v-if="!showPaymentPendingInfo">
          <div class="mypage__attentions">
            <p>{{ $t('coinAttention1') }}</p>
            <p>{{ $t('coinAttention2') }}</p>
            <p>{{ $t('coinAttention3') }}</p>
            <p>{{ $t('coinAttention6') }}</p>
          </div>
        </section>
        <section>
          <div class="mypage__coin_policy">
            <a :href="`${$t('coinPolicyUrl')}`" class="mypage__navigation">
              <ListItem :title="$t('coinPolicy')" :has-disclosure="true" />
            </a>
          </div>
          <div class="mypage__sct_policy">
            <a
              v-if="isRegionJP"
              href="https://reality-public.akamaized.net/legal/sct.html"
              class="mypage__navigation"
            >
              <ListItem :title="$t('sctPolicy')" :has-disclosure="true" />
            </a>
          </div>
          <div class="mypage__coin_history">
            <router-link :to="{ name: 'coin_histories' }">
              <ListItem :title="$t('coinHistory')" :hasDisclosure="true" />
            </router-link>
          </div>
        </section>
      </div>
      <SiteFooter slot="contents" />
    </div>
  </NavigationLayout>
</template>

<script lang="ts">
import { Component, Mixins, Ref, Watch } from 'vue-property-decorator'
import NavigationLayout from '@/components/NavigationLayout.vue'
import SiteHeader from '@/components/Navigation/SiteHeader.vue'
import SegmentedNav from '@/components/Navigation/SegmentedNav.vue'
import SiteFooter from '@/components/Navigation/SiteFooter.vue'
import ListItem from '@/components/ListItem.vue'
import ListSubheader from '@/components/ListSubheader.vue'
import CoinProduct from '@/components/Mypage/CoinProduct.vue'
import LiveImage from '@/components/Mypage/LiveImage.vue'
import MypageStyle from '@/styles/mypage'
import { api } from '@/api/appGatewayServerApi'
import { REGION_JP, LANG_JA, getLanguage } from '@/i18n'
import * as models from '@/models'
import { LanguageQueryHandler } from '@/mixins/LanguageQuery'
import { getDurationString } from '@/utils/time'
import {
  showGenericNetworkError,
  handleUnauthorized,
  sendApiWarning,
} from '@/utils/handle_error'
import { checkInMaintenance } from '@/utils/maintenance'
import Formatter from '@/utils/Formatter'
import {
  checkPurchase,
  ErrorCodePurchaseCannotCancelFinishedPayment,
} from '@/services/gamelib'
import PrimaryButton from '@/components/PrimaryButton.vue'
import { getTokenFromCookie } from '@/utils/token'
import CoinPurchasePending from '@/components/Mypage/CoinPurchasePending.vue'
import CoinPurchasePendingPayPay from '@/components/Mypage/CoinPurchasePendingPayPay.vue'
import CoinPurchasePendingCoinPurchaseBonus from '@/components/Mypage/CoinPurchasePendingCoinPurchaseBonus.vue'
import DangerButton from '@/components/DangerButton.vue'
import { ApiError } from '@/api/error'
import dayjs, { Dayjs } from 'dayjs'
import Cookies from 'js-cookie'
import { calculateBonusAmount } from '@/utils/CoinPurchase'
import { changeInternalLink } from '@/utils/links'

@Component({
  components: {
    NavigationLayout,
    SiteHeader,
    SegmentedNav,
    SiteFooter,
    ListItem,
    ListSubheader,
    CoinProduct,
    LiveImage,
    PrimaryButton,
    CoinPurchasePending,
    CoinPurchasePendingPayPay,
    CoinPurchasePendingCoinPurchaseBonus,
    DangerButton,
  },
})
export default class MyPage extends Mixins(LanguageQueryHandler) {
  calculateBonusAmount = calculateBonusAmount
  changeInternalLink = changeInternalLink

  isLoadingComplete: boolean = false

  afd2025WebGlViewerStartDate!: Dayjs
  afd2025WebGlViewerEndDate!: Dayjs

  SubHeaderWhite = MypageStyle.SubHeaderWhite
  ProviderIdTypes = models.ProviderIdTypes

  coin: number = 0
  medias: models.Media[] = []
  region: string | null = null
  products: models.GamelibProduct[] = []
  groupingProducts: models.GroupeList = {
    campaign: [],
    oncePurchase: [],
    monthlyCoin: [],
    default: [],
  }
  maxSavings: number = 0

  user: models.UserInfo | null = null
  ipRegionIsTransferNG: boolean = false

  showPaymentPendingInfo: boolean = false
  showInProgressCoinPurchaseBonus: boolean = false
  showPaymentPendingProviderId: number = 0

  purchaseStatusList: models.PurchaseStatus[] | null = null

  chargeGrade: models.ChargeGrade | null = null

  chargeLimit: models.WebChargeLimitInfo | null = null
  // isGeoIPRegionJP: アクセス元IPのGeoIP地域が日本か否か（サーバから取得）
  // 課金制限の当月利用額表示（円/有償コイン）の出し分けに使用する。
  // アカウントの地域設定（region）ではなくIPベースの判定値。
  isGeoIPRegionJP: boolean = false

  // serverTime サーバ現在時刻。time shift 時にフロントのリアル時刻ではなくサーバ時刻で判定するために使用。
  serverTime: string = ''

  coinPurchaseBonus: models.CoinPurchaseBonus =
    this.initializeCoinPurchaseBonus()

  canUseLive2DModelUpload: boolean = false

  private initializeCoinPurchaseBonus(): models.CoinPurchaseBonus {
    return {
      vliveId: '',
      rate: 0,
      remainingTimes: 0,
      startAt: new Date(),
      endAt: new Date(),
      canPurchaseBonusProduct: false,
      purchaseInProgress: false,
    }
  }
  coinPurchaseBonusRate: number = 0
  coinBonusProductLimitedCount: number = 0

  paypayTransactionUrl: string | undefined = undefined

  vipPointInfo: models.ChargeGradeVipPointInfo | null = null
  vipPoint: number = 0

  @Ref() readonly chargeGradeProgressCoin!: HTMLDivElement
  chargeGradeProgressCoinOffsetWidth = 0

  setEventListener() {
    const ua = navigator.userAgent
    const isIosSafari = ua.match(/Version\/([0-9._]+).*Mobile.*Safari.*/)
    if (isIosSafari) {
      // ios safariではhistory APIを使ってブラウザバック等を行うと
      // それ以降alert()やconfirm()が一切動かなくなるバグがあるので
      // ブラウザバック時にリロードを行うことで回避する
      window.addEventListener('popstate', function (_: PopStateEvent) {
        window.location.reload()
      })

      // キャッシュから読み込まれた場合も強制リロードかける（bfcache対策）
      window.addEventListener('pageshow', function (e: PageTransitionEvent) {
        if (e.persisted) {
          window.location.reload()
        }
      })
    }
  }

  async created() {
    document.title = `${this.$t('common__webshop').toString()} - REALITY`

    // 2025年4月1日〜7日 限定公開
    this.afd2025WebGlViewerStartDate = dayjs.tz(
      '2025-04-01T00:00:00',
      'Asia/Tokyo'
    )
    this.afd2025WebGlViewerEndDate = dayjs.tz(
      '2025-04-07T23:59:59',
      'Asia/Tokyo'
    )

    try {
      this.isLoadingComplete = false

      await checkPurchase()

      this.setEventListener()

      await this.initializeComponent()

      this.isLoadingComplete = true
    } catch (e) {
      if (checkInMaintenance(e)) {
        alert(this.$t('order_details__alert__cancel_operation'))
        this.$router.push({ path: '/maintenance' }).catch(() => {})
        return
      }
      handleUnauthorized(e)
    }
  }

  async initializeComponent() {
    this.showPaymentPendingInfo = false

    // ローカルストレージから購入画面に移動した時間が残ってる可能性があるので削除
    localStorage.removeItem('moveToPurchaseTime')

    const response = await api().web.mypage._()
    this.medias = response.medias
    this.coin = response.totalCoin
    this.region = response.userInfo.region
    this.products = response.products
    this.user = response.userInfo
    this.ipRegionIsTransferNG = response.isTransferNGRegion
    this.purchaseStatusList = response.purchaseStatusList

    // コインボーナス適用商品を購入できるかどうか
    this.coinPurchaseBonus = response.coinPurchaseBonus
    if (this.canPurchaseCoinPurchaseBonus) {
      this.coinBonusProductLimitedCount = this.coinPurchaseBonus.remainingTimes
      this.coinPurchaseBonusRate = this.coinPurchaseBonus.rate
    }

    // コイン増量適用商品の購入が進行中かどうかを確認
    if (this.coinPurchaseBonus.purchaseInProgress) {
      this.showPaymentPendingInfo = true
      this.showInProgressCoinPurchaseBonus =
        this.coinPurchaseBonus.purchaseInProgress
    }

    this.maxSavings = this.calculateSavings(this.products)
    this.groupingProducts = this.groupByCampaign(this.products)

    // コンビニ決済の決済状態を確認する
    if (this.purchaseStatusList.length !== 0) {
      this.showPaymentPendingInfo = true
      this.showPaymentPendingProviderId = this.purchaseStatusList[0].providerId
      this.paypayTransactionUrl = Cookies.get('paypay_transaction_url')
    } else {
      // もしCookieにまだPayPayの決済URLが残っているなら消しておく
      if (Cookies.get('paypay_transaction_url')) {
        Cookies.remove('paypay_transaction_url', { path: '/' })
      }
    }

    this.chargeGrade = response.chargeGrade
    if (this.chargeGrade && this.chargeGrade.vipPointInfo) {
      this.vipPointInfo = this.chargeGrade.vipPointInfo
    }

    // 課金制限（18歳未満の月間課金上限）の当月利用額
    this.chargeLimit = response.chargeLimit
    this.isGeoIPRegionJP = response.isGeoIPRegionJP
    this.serverTime = response.serverTime

    // VIPポイントの取得
    if (this.vipPointInfo && this.vipPointInfo.total) {
      this.vipPoint = this.vipPointInfo.total
    }

    // live2Dモデルアップロード機能の利用可否
    this.canUseLive2DModelUpload = response.canUseLive2D
  }

  moveToPurchase(product: models.GamelibProduct) {
    // 現在時刻を取得して ローカルストレージに保存しておく（日またぎ購入のバリデーション）
    // （購入タイミングで参照し、日付が変わっている場合はエラーを出してマイページに戻す）

    // ローカルストレージからキーの存在をチェック
    if (localStorage.getItem('moveToPurchaseTime') != null) {
      // 既存のキーが存在する場合は削除
      localStorage.removeItem('moveToPurchaseTime')
    }

    // 現在時刻をローカルストレージに保存
    const now = dayjs().tz('Asia/Tokyo')
    localStorage.setItem('moveToPurchaseTime', now.toISOString())

    const query: Record<string, any> = {
      productId: product.productId,
    }

    if (this.canPurchaseCoinPurchaseBonus) {
      query.isCoinBonusProduct = 1
    }

    this.$router
      .push({
        name: 'coin_purchase',
        query,
      })
      .catch(() => {
        // Nothing to do
      })
  }

  async moveToPayPayPurchase() {
    // PayPay決済画面へ遷移
    if (this.paypayTransactionUrl) {
      location.href = this.paypayTransactionUrl
      return
    }
  }

  // NOTE:後払い決済で決済が未完了な場合のみ決済キャンセル可能
  // （※現状はコンビニ支払い・PayPay決済が対象）
  async purchaseCancel(purchaseId: string, providerId: number) {
    try {
      if (
        !confirm(
          this.$t(
            'convenience_tore_settlement__body__settlement_cancel'
          ).toString()
        )
      ) {
        return
      }

      this.isLoadingComplete = false

      await api().streamer.currency.coin.purchase.postpaid.cancel({
        purchaseId: purchaseId,
        providerId: providerId,
      })
      alert(
        this.$t(
          'convenience_tore_settlement__body__settlement_cancel__completion'
        )
      )

      // 再読み込みする
      await this.initializeComponent()

      this.isLoadingComplete = true
      return
    } catch (e) {
      // 決済完了状態でキャンセルリクエストした場合400エラーになる
      if (
        e instanceof ApiError &&
        e.status === 400 &&
        e.errorCode === ErrorCodePurchaseCannotCancelFinishedPayment
      ) {
        alert(
          this.$t(
            'convenience_tore_settlement__body__settlement_cancel__failure'
          )
        )
      } else {
        // その他のエラーは通常通り処理する
        showGenericNetworkError()
      }
      sendApiWarning(e)

      // 再読み込みする
      await this.initializeComponent()
      this.isLoadingComplete = true
    }
  }

  formatNumber(num: number) {
    return Formatter.numberWithCommas(num)
  }

  getProductLimitedCount(product: models.GamelibProduct) {
    // コインボーナスが適用される商品は、適用される購入可能回数を表示する
    if (this.coinBonusProductLimitedCount > 0) {
      return this.coinBonusProductLimitedCount
    }

    return product.limitedCount
  }

  getRemainTime(time: string | null) {
    // コインボーナスが適用される場合はまず適用期間と商品の終了時間を比較し、早い方の終了時間の方を見て表示させる
    if (this.canPurchaseCoinPurchaseBonus && this.coinPurchaseBonus.endAt) {
      const endAt = dayjs(this.coinPurchaseBonus.endAt)

      // 通常商品などは終了時間がnullの場合があるので、nullの場合は適用期間の終了時間を表示する
      if (time == null) {
        return this.$t('coinCampaignDuration', {
          duration: getDurationString(endAt.toISOString()),
        })
      }

      const productEndTime = dayjs(time)
      time = productEndTime.toISOString()
      // ボーナス適用期間の終了時間が商品の終了時間よりも早い場合は、ボーナス適用期間の終了時間を表示する
      if (endAt.isBefore(productEndTime)) {
        time = endAt.toISOString()
      }
    }

    if (!time) {
      return ''
    }
    return this.$t('coinCampaignDuration', {
      duration: getDurationString(time),
    })
  }

  getRemainTimeForCoinPurchaseBonus(time: Date) {
    // Date to String
    const date = dayjs(time).tz('Asia/Tokyo').format('YYYY/MM/DD HH:mm:ss')
    return this.$t('coinPurchaseBonusRemainTime', {
      duration: getDurationString(date),
    })
  }

  shouldShowTimeLimit(product: models.GamelibProduct) {
    // コインボーナスが適用される場合は商品の終了時間の有無を問わず表示する
    // （実際は商品の終了時間と適用期間終了時間を比較し、早い方の終了時間の方を見て表示させる）
    if (this.canPurchaseCoinPurchaseBonus && this.coinPurchaseBonus.endAt) {
      return true
    }

    // 終了時間がなければ終了時間は表示しない
    if (!product.endTime) {
      return false
    }

    const isCountRemaining = product.limitedCount > 0
    const isLimitedCountCampaign = [
      models.campaignModes.LimitedCountGemIncrease,
      models.campaignModes.LimitedCountSale,
    ].includes(product.campaignMode)

    // 購入回数制限があり、残り回数がない場合は終了時間を表示しない
    if (isLimitedCountCampaign && !isCountRemaining) {
      return false
    }

    return true
  }

  // 1回限りの商品の終了時間を表示するか
  shouldShowTimeLimitForOnceProduct(product: models.GamelibProduct) {
    // 終了時間がなければ終了時間は表示しない
    // 時刻はサポツの設定を見る
    if (!product.productEndTime) {
      return false
    }

    const isOncePurchase = models.isOncePurchaseProduct(product)
    const now = dayjs().tz('Asia/Tokyo')
    const isLessThanOneMonth =
      dayjs(product.productEndTime).diff(now, 'month') < 1

    if (!isOncePurchase || !isLessThanOneMonth) {
      return false
    }

    return true
  }

  calculateSavings(products: models.GamelibProduct[]) {
    let maxSavings = 0
    let bestProduct: models.GamelibProduct | null = null

    for (const product of products) {
      const chargeCoin = product.chargeGem // チャージコイン
      let bonusCoin = product.freeGem // 増加分コイン

      // コインボーナス商品の場合はさらに増加分コインを加算する
      if (this.canPurchaseCoinPurchaseBonus && this.coinPurchaseBonusRate > 0) {
        bonusCoin += this.calculateBonusAmount(
          product.chargeGem,
          this.coinPurchaseBonusRate
        )
      }

      const savingsPercentage = Math.round((bonusCoin / chargeCoin) * 100) // 小数第二位で四捨五入

      // 商品の中から一番増量率が高いものを取り出す
      if (savingsPercentage > maxSavings) {
        maxSavings = savingsPercentage
        bestProduct = product
      }
    }

    if (bestProduct !== null) {
      return maxSavings
    } else {
      // 商品がない場合
      return 0
    }
  }

  // groupByCampaign キャンペーン商品・1回限りの商品・それ以外の商品でグルーピングする
  groupByCampaign(products: models.GamelibProduct[]) {
    const groupedData: models.GroupeList = {
      campaign: [],
      oncePurchase: [],
      monthlyCoin: [],
      default: [],
    }

    const defaultGroupKey = 'null_null'

    // 日付に変換して終了日の昇順にソート
    const sortedProducts = [...products].sort((a, b) => {
      // データとしてnullが入りうる
      // nullの場合は1970/01/01 00:00:00として扱う
      const dateA = a.endTime ? new Date(a.endTime) : new Date(0)
      const dateB = b.endTime ? new Date(b.endTime) : new Date(0)
      return dateA.getTime() - dateB.getTime()
    })

    for (const product of sortedProducts) {
      let isCampaignGroupProduct = false
      let isOncePurchaseGroupProduct = false
      let isMonthlyCoinGroupProduct = false

      // 商品に対してキャンペーン設定がされているかの確認
      if (models.isCampaignProduct(product)) {
        // マンスリーコインかどうか
        if (models.isMonthlyCoinProduct(product)) {
          isMonthlyCoinGroupProduct = true
        } else {
          isCampaignGroupProduct = true
        }
        //  商品に対して初回限りの購入設定がされているかの確認
      } else if (models.isOncePurchaseProduct(product)) {
        isOncePurchaseGroupProduct = true
      }
      // 「5:商品が購入回数制限の有償ジェム増量」or「6:購入回数制限の価格割引」の場合は購入回数制限が0ではないかをチェックする
      // ※購入回数制限が0の場合は、default商品として扱うので、キャンペーン商品として扱わない
      //  （productIdは切り替わるが、campaignTypeとcampaignModeは設定時の値のままの為、ここで購入回数制限の値をチェックする必要がある）
      if (models.isLimitedCampaignWithNoRemaining(product)) {
        isCampaignGroupProduct = false
        isMonthlyCoinGroupProduct = false
      }

      if (isCampaignGroupProduct) {
        // キャンペーン設定されている商品はcampaignグループに追加
        const groupKey = `${product.startTime}_${product.endTime}`
        const campaignGroup = groupedData.campaign.find(
          (group) => group.group === groupKey
        )

        if (!campaignGroup) {
          groupedData.campaign.push({
            group: groupKey,
            products: [product],
          })
        } else {
          campaignGroup.products.push(product)
        }
      } else if (isOncePurchaseGroupProduct) {
        // 1回限りの購入設定されている商品はoncePurchaseグループに追加
        const oncePurchaseGroup = groupedData.oncePurchase.find(
          (group) => group.group === defaultGroupKey
        )

        if (!oncePurchaseGroup) {
          groupedData.oncePurchase.push({
            group: defaultGroupKey,
            products: [product],
          })
        } else {
          oncePurchaseGroup.products.push(product)
        }
      } else if (isMonthlyCoinGroupProduct) {
        // マンスリーコイングループ
        const monthlyCoinGroup = groupedData.monthlyCoin.find(
          (group) => group.group === defaultGroupKey
        )

        if (!monthlyCoinGroup) {
          groupedData.monthlyCoin.push({
            group: defaultGroupKey,
            products: [product],
          })
        } else {
          monthlyCoinGroup.products.push(product)
        }
      } else {
        // キャンペーン以外はdefaultグループに追加
        const defaultGroup = groupedData.default.find(
          (group) => group.group === defaultGroupKey
        )

        if (!defaultGroup) {
          groupedData.default.push({
            group: defaultGroupKey,
            products: [product],
          })
        } else {
          defaultGroup.products.push(product)
        }
      }
    }

    // それぞれのグループ内で価格のソートを行う
    // キャンペーン商品
    for (const campaignProducts of groupedData.campaign) {
      // 価格の昇順にソート
      campaignProducts.products.sort((a, b) => a.price - b.price)
    }

    // 1回限りの限定商品
    for (const oncePurchaseProducts of groupedData.oncePurchase) {
      // 価格の昇順にソート
      oncePurchaseProducts.products.sort((a, b) => a.price - b.price)
    }

    // マンスリーコイン
    for (const monthlyCoinProducts of groupedData.monthlyCoin) {
      // 価格の昇順にソート
      monthlyCoinProducts.products.sort((a, b) => a.price - b.price)
    }

    // 通常商品
    for (const campaignProducts of groupedData.default) {
      // 価格の昇順にソート
      campaignProducts.products.sort((a, b) => a.price - b.price)
    }

    return groupedData
  }

  get maxSavingsValueText() {
    // NOTE: ここは翻訳が必要ないが、JPとその他で出し分けはしたいので、直接文字列を返す
    if (this.isLanguageJa) {
      // xxx%の部分
      return `${this.maxSavings}%`
    } else {
      return `${this.maxSavings}%!`
    }
  }

  get maxSavingsIncreaseText() {
    // NOTE: ここは翻訳が必要ないが、JPとその他で出し分けはしたいので、直接文字列を返す
    if (this.isLanguageJa) {
      // 増量の部分
      return '増量！'
    } else {
      return ''
    }
  }

  get isRegionJP() {
    return this.region === REGION_JP
  }

  get chargeLimitProgressText(): string {
    if (!this.chargeLimit) return ''
    const usage = Formatter.numberWithCommas(this.chargeLimit.usage)
    const maxLimit = Formatter.numberWithCommas(this.chargeLimit.maxLimit)
    return this.isGeoIPRegionJP
      ? this.$t('charge_limit__label__current_month_progress_jp', [
          usage,
          maxLimit,
        ]).toString()
      : this.$t('charge_limit__label__current_month_progress_except_jp', [
          usage,
          maxLimit,
        ]).toString()
  }

  get isLanguageJa() {
    return getLanguage() === LANG_JA
  }

  get coinItemClass() {
    return 'coin_item -' + this.$i18n.locale
  }

  get localeClass() {
    return '-' + this.$i18n.locale
  }

  get isUserWebview(): boolean {
    return getTokenFromCookie() !== undefined
  }

  get currentChargeGradeThreshold(): models.ChargeGradeThresholdSetting | null {
    if (!this.chargeGrade) {
      return null
    }

    const totalAmount = this.chargeGrade.totalChargeGradeAmount

    return (
      this.chargeGrade.currentThresholdSettings.find((threshold) => {
        if (!threshold) {
          return false
        }

        const isInRange =
          totalAmount >= threshold.lowAmountRange &&
          (totalAmount < threshold.highAmountRange || threshold.isMax)

        return isInRange
      }) ?? null
    )
  }

  get centerChargeGradeThreshold(): models.ChargeGradeThresholdSetting | null {
    if (!this.chargeGrade) {
      return null
    }

    // データは2つか3つのサイズで来る
    if (this.chargeGrade.currentThresholdSettings.length < 3) {
      return this.chargeGrade.currentThresholdSettings[0]
    }

    return this.chargeGrade.currentThresholdSettings[1]
  }

  get rightChargeGradeThreshold(): models.ChargeGradeThresholdSetting | null {
    if (!this.chargeGrade) {
      return null
    }

    // データは2つか3つのサイズで来る
    if (this.chargeGrade.currentThresholdSettings.length < 3) {
      return this.chargeGrade.currentThresholdSettings[1]
    }

    return this.chargeGrade.currentThresholdSettings[2]
  }

  get totalChargeGradeAmount(): string {
    if (!this.chargeGrade) {
      return ''
    }

    return Formatter.numberWithCommas(this.chargeGrade.totalChargeGradeAmount)
  }

  // コイン増量が購入可能かつ購入可能期間内の場合はtrue
  get canPurchaseCoinPurchaseBonus() {
    if (
      !this.coinPurchaseBonus.canPurchaseBonusProduct || // コインボーナスが適用される商品が購入可能でない
      this.coinPurchaseBonus.purchaseInProgress // 購入が進行中の場合は購入できない
    ) {
      return false
    }

    const now = this.serverTime
      ? dayjs(this.serverTime).tz('Asia/Tokyo')
      : dayjs().tz('Asia/Tokyo')
    const startAt = dayjs(this.coinPurchaseBonus.startAt).tz('Asia/Tokyo')
    const endAt = dayjs(this.coinPurchaseBonus.endAt).tz('Asia/Tokyo')

    // 現在時刻が購入可能期間内かを確認し期間外の場合はfalseを返す
    if (!(now.isAfter(startAt) && now.isBefore(endAt))) {
      return false
    }

    return true
  }

  @Watch('totalChargeGradeAmount', { immediate: true })
  onTotalChargeGradeAmount() {
    this.$nextTick(() => {
      this.chargeGradeProgressCoinOffsetWidth =
        this.chargeGradeProgressCoin.offsetWidth
    })
  }

  get styleChargeGradeBackgroundImage(): string {
    if (!this.currentChargeGradeThreshold) {
      return ''
    }

    return `background-image: url(${this.currentChargeGradeThreshold.backgroundImageUrl})`
  }

  get styleChargeGradeProgress(): string {
    if (!this.currentChargeGradeThreshold) {
      return ''
    }

    if (
      this.currentChargeGradeThreshold.lowAmountRange === 0 ||
      this.currentChargeGradeThreshold.isMin
    ) {
      return `
        width: calc(100% - 19px);
        margin-left: 0px;
      `
    }

    return `
      width: calc(100% - 19px + 16px);
      margin-left: -16px;
    `
  }

  get styleChargeGradeProgressBar(): string {
    if (!this.currentChargeGradeThreshold) {
      return ''
    }

    if (!this.rightChargeGradeThreshold) {
      return ''
    }

    // 左角丸
    if (
      this.currentChargeGradeThreshold.lowAmountRange === 0 ||
      this.currentChargeGradeThreshold.isMin
    ) {
      return `
        width: calc(100% + 35px);
        margin-right: -35px;
        border-radius: 99px 0px 0px 99px;
      `
    }

    // 右角丸
    if (this.rightChargeGradeThreshold.isMax) {
      return `
        width: 100%;
        margin-right: 0px;
        border-radius: 0px 99px 99px 00px;
      `
    }

    // 角丸なし
    return `
        width: calc(100% + 35px);
        margin-right: -35px;
        border-radius: 0px 0px 0px 0px;
      `
  }

  get styleChargeGradeProgressBarGauge(): string {
    if (!this.chargeGrade) {
      return ''
    }

    if (!this.currentChargeGradeThreshold) {
      return ''
    }

    if (!this.centerChargeGradeThreshold) {
      return ''
    }

    if (!this.rightChargeGradeThreshold) {
      return ''
    }

    let width = 0

    const now = this.currentChargeGradeThreshold.isMax
      ? 100
      : this.chargeGrade.totalChargeGradeAmount -
        this.currentChargeGradeThreshold.lowAmountRange
    const max = this.currentChargeGradeThreshold.isMax
      ? 100
      : this.currentChargeGradeThreshold.highAmountRange -
        this.currentChargeGradeThreshold.lowAmountRange

    if (
      this.currentChargeGradeThreshold.id !==
        this.centerChargeGradeThreshold.id &&
      !this.currentChargeGradeThreshold.isMax
    ) {
      width = (now / max) * 50
    } else {
      width = (now / max) * 50 + 50
    }

    if (width > 100) {
      width = 100
    }

    // 左角丸
    if (
      this.currentChargeGradeThreshold.lowAmountRange === 0 ||
      this.currentChargeGradeThreshold.isMin
    ) {
      return `
        width: ${width}%;
        border-radius: 99px 0px 0px 99px;
      `
    }

    // 右角丸
    if (this.rightChargeGradeThreshold.isMax) {
      return `
        width: ${width}%;
        border-radius: 0px 99px 99px 00px;
      `
    }

    // 角丸なし
    return `
        width: ${width}%;
        border-radius: 0px 0px 0px 0px;
      `
  }

  get styleChargeGradeProgressCoin(): string {
    if (!this.chargeGrade) {
      return ''
    }

    if (!this.currentChargeGradeThreshold) {
      return ''
    }

    if (!this.centerChargeGradeThreshold) {
      return ''
    }

    if (!this.rightChargeGradeThreshold) {
      return ''
    }

    let left = 0

    const now = this.currentChargeGradeThreshold.isMax
      ? 100
      : this.chargeGrade.totalChargeGradeAmount -
        this.currentChargeGradeThreshold.lowAmountRange
    const max = this.currentChargeGradeThreshold.isMax
      ? 100
      : this.currentChargeGradeThreshold.highAmountRange -
        this.currentChargeGradeThreshold.lowAmountRange

    if (
      this.currentChargeGradeThreshold.id !==
        this.centerChargeGradeThreshold.id &&
      !this.currentChargeGradeThreshold.isMax
    ) {
      left = (now / max) * 50
    } else {
      left = (now / max) * 50 + 50
    }

    if (left > 100) {
      left = 100
    }

    if (left >= 50) {
      // 右寄せの計算
      return `
      right: max(calc(${100 - left}% - ${
        this.chargeGradeProgressCoinOffsetWidth / 2
      }px), -20px);
      `
    }

    // 未獲得の場合
    if (this.currentChargeGradeThreshold.lowAmountRange === 0) {
      // 左寄せの計算
      return `
      left: max(calc(${left}% - ${
        this.chargeGradeProgressCoinOffsetWidth / 2
      }px), 0px);
      `
    }

    return `
    left: max(calc(${left}% - ${
      this.chargeGradeProgressCoinOffsetWidth / 2
    }px), 12px);
    `
  }

  /**
   * エープリルフール2025のWeb版REALITYのバナーを表示可能か
   */
  private canShowWebGlViewerAfd2025() {
    const now = dayjs().tz('Asia/Tokyo')
    return (
      now.isAfter(this.afd2025WebGlViewerStartDate) &&
      now.isBefore(this.afd2025WebGlViewerEndDate)
    )
  }

  get isJapanese() {
    return getLanguage() === LANG_JA
  }
}
</script>

<style scoped>
body {
  overflow-x: hidden;
  height: 100%;
}

/* SiteHeader と mypage__wrapper の間に表示する Webショップナビ */
.mypage__web_shop_nav {
  width: 100%;
  max-width: 832px;
  margin: 0 auto;
  padding: 24px 16px 0;
}

#mypage__wrapper {
  position: relative;
  min-width: 375px;
  height: auto;
  min-height: 100%;
  padding: 0 0 var(--safe-area-inset-bottom, 0px) 0;
}

#mypage__container {
  font-size: 14px;
  line-height: 1.43;
  color: #262626;
  padding-top: 24px;
  padding-bottom: 80px;

  & .lives_section {
    @media (min-width: 800px) {
      width: 800px;
      margin: 0 auto;
    }
  }
}

#mypage__header {
  padding: 20px 14px;
  margin-top: 0;
  text-align: left;
  background-color: #ffffff;
  line-height: 1.5;
  color: #383838;
}

section {
  padding-bottom: 24px;
}

.bl_coinPurchasePending_wrapper {
  padding: 16px 16px 16px 16px;

  @media (min-width: 800px) {
    width: 800px;
    margin: 0 auto;
  }
}

.bl_coinPurchasePending {
  padding-top: 4px;
  padding-bottom: 32px;
  border-bottom: #e8e8e8 solid 1px;
}

.mypage__navigation {
  cursor: pointer;
  pointer-events: auto;
}

.mypage__attentions {
  padding: 0 14px;
  margin: 8px 0 14px;
  font-size: 12px;
  line-height: 150%;
  color: #808080;
}

@media (min-width: 800px) {
  .mypage__attentions {
    width: 800px;
    margin: 0 auto;
    margin-bottom: 16px;
  }
}

@media (min-width: 800px) {
  .mypage__coin_policy,
  .mypage__sct_policy,
  .mypage__coin_history {
    width: 800px;
    margin: 0 auto;
  }
}

.lives_wrapper {
  & /deep/ .live_info {
    margin: 0 auto;
  }
}

.coin_possessed {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 16px;
}

.campaign_group_wrapper {
  background-color: #ffffff;
}

.campaign_group .coin_list {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin: 16px 16px 0;
}

.campaign_group .coin_list .coin_item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  width: 100%;
  background-color: #ffffff;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  cursor: pointer;
}

.campaign_group .coin_list .coin_item:hover {
  background-color: #f2f2f2;
}

.campaign_group .coin_list .coin_item:active {
  background-color: #e8e8e8;
}

@media (min-width: 832px) {
  .campaign_group .coin_list .coin_item {
    width: 800px;
  }
}

.campaign_group .coin_list .coin_item .coin_price {
  -webkit-text-size-adjust: 100%;
  font-weight: 700;
  font-size: 12px;
  height: 24px;
  min-width: 80px;
  width: auto;
  /* 価格のテキスト長がmin-widthを超えた場合 */
  white-space: nowrap;
  /* 価格テキストを折り返さない */
  padding: 1px 12px;
}

.coin_purchase {
  color: black;
}

.coin_group_title {
  font-size: 12px;
  text-align: left;
  font-weight: 400;
  border-left: 4px solid #bb77ff;

  margin-top: 0px;
  margin-bottom: 0px;
  margin-right: 16px;
  margin-left: 16px;

  padding: 0px 14px;
  width: 100%;

  @media (min-width: 832px) {
    width: 800px;
    margin-right: auto;
    margin-left: auto;
  }

  & p {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #0f0f0f;
  }

  & b {
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
    letter-spacing: 0.15px;
  }
}

div .banner_section {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 120px;
}

@media (min-width: 800px) {
  div .banner_section {
    margin: 0 auto 0px;
  }
}

div .banner_wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-height: 120px;
  width: 100%;
  margin: 0 auto;
  background-image: url('/img/web_coinshop_banner_campaign.png'),
    url('/img/web_coinshop_banner_bg.jpg');
  background-repeat: no-repeat;
  background-position: right 16px bottom, left 0;
  background-size: 180px 120px, 800px;
}

@media (min-width: 800px) {
  div .banner_wrapper {
    background-size: 180px 120px, 100%;
  }
}

@media (min-width: 832px) {
  div .banner_wrapper {
    background-position: calc(50% + 310px) bottom, left 0;
  }
}

div .banner_wrapper .banner_wrapper_front,
div .banner_wrapper .banner_wrapper_shadow {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  min-height: 120px;
  gap: 8px;
  flex: none;
  order: 0;
  flex-grow: 0;
}

div .banner_wrapper .banner_wrapper_front {
  z-index: 1;
}

div .banner_wrapper .banner_wrapper_shadow {
  z-index: 0;
}

div .banner_wrapper .banner_wrapper_shadow .banner_text .banner_text_line1,
div .banner_wrapper .banner_wrapper_shadow .banner_text .banner_text_line2 {
  background: linear-gradient(90deg, #0055ff 0%, #ff00d4 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  filter: blur(5px);
}

@media (max-width: 800px) {
  div .banner_wrapper .banner_wrapper_shadow .banner_text .banner_text_line3,
  div .banner_wrapper .banner_wrapper_shadow .banner_text .banner_text_line4 {
    background: linear-gradient(90deg, #0055ff 0%, #ff00d4 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    filter: blur(5px);
  }
}

div .banner_wrapper .banner_text {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: fit-content;
  margin: 0 16px;
  padding: 0;
  font-style: normal;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}

@media (min-width: 832px) {
  div .banner_wrapper .banner_text {
    width: 800px;
    margin: 0 auto;
  }
}

div .banner_wrapper .banner_text .banner_text_line1 {
  display: flex;
  width: fit-content;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.4px;
  color: #ffffff;
}

@media (min-width: 800px) {
  div .banner_wrapper .banner_text .banner_text_line1 {
    font-size: 20px;
  }
}

div .banner_wrapper .banner_text .banner_text_line2 {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: fit-content;
}

@media (min-width: 800px) {
  div .banner_wrapper .banner_text .banner_text_line2 {
    flex-direction: row;
    justify-content: flex-start;
  }
}

div .banner_wrapper .banner_text .banner_text_line3,
div .banner_wrapper .banner_text .banner_text_line4 {
  display: flex;
  width: fit-content;
  align-items: flex-end;
  font-weight: 700;
  color: #ffffff;
}

div .banner_wrapper .banner_text .banner_text_line3 {
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 0.4px;
}

@media (min-width: 800px) {
  div .banner_wrapper .banner_text .banner_text_line3 {
    font-size: 30px;
    line-height: 36px;
    height: 44px;
  }
}

div .banner_wrapper .banner_text .banner_text_line4 {
  font-size: 32px;
  line-height: 32px;
  letter-spacing: 0.4px;
  height: 38px;
}

@media (min-width: 800px) {
  div .banner_wrapper .banner_text .banner_text_line4 {
    font-size: 40px;
    line-height: 44px;
    height: 44px;
  }
}

div .banner_wrapper .banner_text .banner_text_line4 .banner_text_line5 {
  display: flex;
  align-items: flex-end;
  height: 38px;
  font-size: 16px;
  line-height: 16px;
  margin-bottom: 2px;
  margin-left: 2px;
}

@media (min-width: 800px) {
  div .banner_wrapper .banner_text .banner_text_line4 .banner_text_line5 {
    font-size: 30px;
    line-height: 36px;
    height: 44px;
    margin-left: 0px;
    margin-bottom: 0px;
  }
}

.banner {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 500px;
  height: calc(100% * 0.5);
  background-size: cover;
  background-position: center;
  border-radius: 8px;
  margin: 0 0 8px 0;
}

.danger_button {
  margin-top: 24px;
}

.charge_grade_wrapper {
  background-color: #ffffff;
}

.charge_grade_group {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin: 0px 16px 0;
}

.charge_grade_group .charge_grade_item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 16px 16px;
  width: 100%;
  max-width: 500px;
  height: 144px;
  border-radius: 8px;
  background-color: #cccccc;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  gap: 8px;
}

@media (min-width: 832px) {
  .charge_grade_group .charge_grade_item {
    width: 500px;
  }
}

.charge_grade_group .charge_grade_item .charge_grade_status {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  gap: 10px;

  width: 100%;
  height: 48px;
}

.charge_grade_group
  .charge_grade_item
  .charge_grade_status
  .charge_grade_status_detail {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 2px;
}

.charge_grade_group
  .charge_grade_item
  .charge_grade_status
  .charge_grade_status_detail
  .charge_grade_status_detail_title {
  display: flex;
  justify-content: flex-start;

  height: 16px;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #ffffff;
}

.charge_grade_group
  .charge_grade_item
  .charge_grade_status
  .charge_grade_status_detail
  .charge_grade_status_detail_icon_block {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;

  height: auto;
}

.charge_grade_group
  .charge_grade_item
  .charge_grade_status
  .charge_grade_status_detail
  .charge_grade_status_detail_icon_block
  .charge_grade_status_detail_icon_block_icon_img {
  display: flex;
  justify-content: flex-start;

  width: 30px;
  height: 30px;
  color: #000000;
  margin: 1px 1px 1px 1px;
}

.charge_grade_group
  .charge_grade_item
  .charge_grade_status
  .charge_grade_status_detail
  .charge_grade_status_detail_icon_block
  .charge_grade_status_detail_icon_block_icon_title {
  display: flex;
  justify-content: flex-start;

  max-width: 238px;
  height: 30px;

  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0.15px;
  color: #ffffff;
  overflow: visible;
  white-space: nowrap;
}

.charge_grade_group
  .charge_grade_item
  .charge_grade_status
  .charge_grade_status_detail
  .charge_grade_status_detail_icon_block
  .charge_grade_status_detail_icon_block_icon_vip_point {
  display: flex;
  justify-content: flex-start;
  margin-top: 4px;
  width: 100%;

  font-weight: 400;
  font-size: 12px;
  letter-spacing: 0.4px;
  color: #ffffff;

  a {
    color: #ffffff;
    text-decoration: none;
    width: 100%;
  }

  .vip_point_link {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .vip_point_text {
    margin-right: 4px;
  }

  .vip_point_amount {
    font-weight: 700;
    font-size: 14px;
  }

  .vip_point_arrow {
    width: 12px;
    height: 12px;
    vertical-align: middle;
  }
}

.charge_grade_group .charge_grade_item .charge_grade_progress {
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-direction: column;

  height: 22px;

  margin-right: 19px;

  margin-bottom: 10px;
}

.charge_grade_group
  .charge_grade_item
  .charge_grade_progress
  .charge_grade_progress_bar {
  display: flex;
  height: 4px;
  background: rgba(255, 255, 255, 0.5);
  z-index: 1;
}

.charge_grade_group
  .charge_grade_item
  .charge_grade_progress
  .charge_grade_progress_bar_wrapper {
  position: absolute;
  display: flex;
  width: 100%;
  height: 4px;
}

.charge_grade_group
  .charge_grade_item
  .charge_grade_progress
  .charge_grade_progress_bar_wrapper
  .charge_grade_progress_bar_gauge {
  height: 4px;
  background: #188dff;

  z-index: 2;
}

.charge_grade_group .charge_grade_item .charge_grade_status {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0px;
  gap: 10px;

  width: 100%;
  height: 60px;
  padding-top: 10px;
}

.charge_grade_group
  .charge_grade_item
  .charge_grade_progress
  .charge_grade_progress_bar_wrapper
  .charge_grade_progress_right_point {
  width: 4px;
  height: 4px;
  left: calc(100% - 2px);
  background-image: url('/img/gauge_circle.png');
  background-size: 4px 4px;
  position: absolute;
  z-index: 3;
}

.charge_grade_group
  .charge_grade_item
  .charge_grade_progress
  .charge_grade_progress_icon_center {
  position: absolute;
  width: 20px;
  height: 20px;
  top: -6px;
  left: calc(50% - 10px);
  margin: 0 auto;
}

.charge_grade_group
  .charge_grade_item
  .charge_grade_progress
  .charge_grade_progress_icon_right {
  position: absolute;
  width: 20px;
  height: 20px;
  top: -6px;
  left: calc(100% - 10px);
  margin: 0 auto;
}

.charge_grade_group
  .charge_grade_item
  .charge_grade_progress
  .charge_grade_progress_coin {
  display: flex;
  width: 100%;
  height: 0px;
}

.charge_grade_group
  .charge_grade_item
  .charge_grade_progress
  .charge_grade_progress_coin
  .charge_grade_progress_coin_wrapper {
  position: absolute;
  height: 16px;
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 16px;
  text-align: center;
  color: #ffffff;
  white-space: nowrap;
}

.afd-banner-center-div {
  display: flex;
  justify-content: center;

  img {
    width: 100%;
    min-width: 400px;
    max-width: 800px;
  }
}

@media (min-width: 832px) {
  .coin_purchase_bonus_content {
    width: 500px;
  }
}

.charge_limit_wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0px 16px 16px 16px;
  font-family: 'Hiragino Kaku Gothic ProN', 'Hiragino Sans', sans-serif;
  font-style: normal;

  @media (min-width: 800px) {
    width: 800px;
    margin: 0 auto 16px;
  }
}

.charge_limit_label {
  font-weight: 300;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #737373;
}

.charge_limit_progress {
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #737373;
}

.coin_purchase_bonus_wrapper {
  font-style: normal;
  margin: 0px 16px;
}

.coin_purchase_bonus_content {
  position: relative; /* 絶対位置指定の基準 */
  background-color: #188dff0d;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 500px;
  border: 1px solid #188dff;
  border-radius: 8px;
  margin: 0 auto;
  padding: 16px 16px 8px 16px;
}

.coin_purchase_bonus_content_top {
  text-align: center;
  width: 100%;
}

.coin_purchase_bonus_content_top_text {
  text-align: center;
  font-size: 12px;
  color: #000000;
}

.coin_purchase_bonus_content_rate {
  font-size: 24px;
  font-weight: 700;
  color: #000000;
  padding: 8px 0px 8px 0px;
  border-radius: 4px;
}

.coin_purchase_bonus_content_limit_display {
  background-color: #188dff;
  border-radius: 4px;
  padding: 2px 16px 2px 16px;
  margin: 0px 0px 16px 0px;
  min-height: 16px;
}

.coin_purchase_bonus_content_limit_display_text {
  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
}

.coin_purchase_bonus_content_bottom_text {
  font-size: 10px;
  font-weight: 400;
  color: #7b7b7b;
}
</style>
